import axios from 'axios';
import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const getFeatureToggleByName = async featureName => {
  const opt = getOptions();
  opt.params = { name: featureName };
  return (await requestFunnel.get('features-toggles', opt)).data;
};

export const getAllFeaturesToggles = async () => (await requestFunnel.get('features-toggles', getOptions())).data;

export const updateFeatureToggle = async (featureToggleId, isActive, featureToggleOptionsToUpdate, cancelExecutor = () => {}) => {
  const cancelToken = new axios.CancelToken(cancelExecutor);
  const requestOptions = getOptions();
  requestOptions.cancelToken = cancelToken;
  return (await requestFunnel.patch(`features-toggles/${featureToggleId}`, { isActive, options: featureToggleOptionsToUpdate }, requestOptions)).data;
};
